import { render, staticRenderFns } from "./headTip.vue?vue&type=template&id=663178d4&scoped=true&"
import script from "./headTip.vue?vue&type=script&lang=js&"
export * from "./headTip.vue?vue&type=script&lang=js&"
import style0 from "./headTip.vue?vue&type=style&index=0&id=663178d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663178d4",
  null
  
)

export default component.exports